import {
  LOGIN_REQUEST,
  FETCH_AUTHENTICATED_USER_SUCCESS,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SET_LOGIN_ERROR,
  SET_SIDEBAR_STATE,
  INIT_REQUEST,
  SET_TOKEN,
  FETCH_AUTHENTICATED_USER_REQUEST,
} from './actionTypes'

export function login() {
  return {
    type: LOGIN_REQUEST,
  }
}

export function setInitRequest(initCompleted: boolean) {
  return {
    type: INIT_REQUEST,
    initCompleted,
  }
}

export function fetchAuthenticatedUserSuccess(user: any) {
  return {
    type: FETCH_AUTHENTICATED_USER_SUCCESS,
    user,
  }
}

export function logout() {
  return {
    type: LOGOUT_REQUEST,
  }
}

export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
  }
}

export function setLoginError(error: any) {
  return {
    type: SET_LOGIN_ERROR,
    error,
  }
}

export function setSidebarState(data: string) {
  return {
    type: SET_SIDEBAR_STATE,
    data,
  }
}

export function setToken(token: any) {
  return {
    type: SET_TOKEN,
    token,
  }
}

export function fetchAuthenticatedUser() {
  return {
    type: FETCH_AUTHENTICATED_USER_REQUEST,
  }
}
